var render = function () {
  var _vm$currentRound, _vm$currentRound$comp, _vm$currentRound$comp2, _vm$currentRound2, _vm$currentRound2$com, _vm$currentRound2$com2, _vm$currentRound3, _vm$currentRound3$emp, _vm$currentRound3$emp2, _vm$currentRound4, _vm$currentRound4$emp, _vm$currentRound4$emp2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('article', [_c('activity-stage', {
    attrs: {
      "customRootContainerClass": 'full-height'
    }
  }, [_c('template', {
    slot: "instructions"
  }, [_vm._t("instructions")], 2), _c('article', {
    staticStyle: {
      "height": "100%"
    },
    attrs: {
      "slot": "content"
    },
    slot: "content"
  }, [_c('assessment-helper'), _c('div', {
    staticClass: "mat-man-match"
  }, [_vm.showImage ? _c('div', {
    staticClass: "drag-completed"
  }, [_c('span', {
    staticClass: "image-header"
  }, [_vm._v(_vm._s(_vm.currentRound.shape))]), _c('img', {
    staticClass: "completed-image",
    attrs: {
      "alt": (_vm$currentRound = _vm.currentRound) === null || _vm$currentRound === void 0 ? void 0 : (_vm$currentRound$comp = _vm$currentRound.completedImage) === null || _vm$currentRound$comp === void 0 ? void 0 : (_vm$currentRound$comp2 = _vm$currentRound$comp.image) === null || _vm$currentRound$comp2 === void 0 ? void 0 : _vm$currentRound$comp2.description,
      "src": (_vm$currentRound2 = _vm.currentRound) === null || _vm$currentRound2 === void 0 ? void 0 : (_vm$currentRound2$com = _vm$currentRound2.completedImage) === null || _vm$currentRound2$com === void 0 ? void 0 : (_vm$currentRound2$com2 = _vm$currentRound2$com.image) === null || _vm$currentRound2$com2 === void 0 ? void 0 : _vm$currentRound2$com2.src
    }
  })]) : _vm._e(), !_vm.showImage ? _c('div', {
    staticClass: "drag-panel"
  }, [_c('div', {
    staticClass: "drag-container"
  }, [_c('img', {
    attrs: {
      "alt": (_vm$currentRound3 = _vm.currentRound) === null || _vm$currentRound3 === void 0 ? void 0 : (_vm$currentRound3$emp = _vm$currentRound3.emptyImage) === null || _vm$currentRound3$emp === void 0 ? void 0 : (_vm$currentRound3$emp2 = _vm$currentRound3$emp.image) === null || _vm$currentRound3$emp2 === void 0 ? void 0 : _vm$currentRound3$emp2.description,
      "aria-label": ("Droppable area for " + (_vm.currentRound.shape)),
      "id": "dragging-area",
      "src": (_vm$currentRound4 = _vm.currentRound) === null || _vm$currentRound4 === void 0 ? void 0 : (_vm$currentRound4$emp = _vm$currentRound4.emptyImage) === null || _vm$currentRound4$emp === void 0 ? void 0 : (_vm$currentRound4$emp2 = _vm$currentRound4$emp.image) === null || _vm$currentRound4$emp2 === void 0 ? void 0 : _vm$currentRound4$emp2.src
    }
  })]), _c('div', {
    staticClass: "draggable-items",
    class: {
      isMobile: _vm.isMobile
    }
  }, _vm._l(_vm.currentRound.answers, function (answer, index) {
    return _c('button', {
      key: index,
      staticClass: "draggable-item pure-button",
      attrs: {
        "aria-label": answer.shape
      },
      on: {
        "keyup": function ($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.handleOnShapeEnterEvent($event);
        }
      }
    }, [_c('div', {
      staticClass: "image-container"
    }, [_c('img', {
      staticClass: "selected-image",
      attrs: {
        "alt": answer.shape,
        "id": answer.shape,
        "src": answer.selectedImage.image.src
      }
    }), _c('img', {
      staticClass: "unselected-image",
      attrs: {
        "alt": "",
        "src": answer.unselectedImage.image.src
      }
    })]), _c('div', {
      staticClass: "image-text"
    }, [_vm._v(_vm._s(answer.shape))])]);
  }), 0)]) : _vm._e()]), _c('span', {
    attrs: {
      "aria-atomic": "true",
      "id": "hidden-mat-man-activity-description",
      "role": "alert"
    }
  }, [_vm._v("Mat Man's torso.")])], 1)], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }